var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "-16 -16 232 232",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-43.806489 100 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 89A74 74 0 0 1 100 27",
    stroke: "#030b1d",
    strokeWidth: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 102A74 74 0 0 0 96 174M108 174A74 74 0 0 0 168 85",
    stroke: "#030b1d",
    strokeWidth: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 111L129 65L82 114Z",
    fill: "#030b1d",
    stroke: "#030b1d",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 114L129 65L93 156Z",
    fill: "#030b1d",
    stroke: "#030b1d",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 55,
    r: 13,
    fill: "#030b1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 29A43 43 0 0 1 173 62",
    stroke: "#030b1d",
    strokeWidth: 9,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 13A59 59 0 0 1 188 58",
    stroke: "#030b1d",
    strokeWidth: 9,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 89A74 74 0 0 1 100 27",
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 102A74 74 0 0 0 96 174M108 174A74 74 0 0 0 168 85",
    stroke: "#22c55e",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 111L129 65L82 114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 114L129 65L93 156Z",
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 55,
    r: 10,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("g", {
    className: "divi-radio",
    stroke: "#22c55e",
    strokeWidth: 5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 29A43 43 0 0 1 173 62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 13A59 59 0 0 1 188 58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.64684ffc9ad06928dc859b9ef94acfa9.svg";
export { ForwardRef as ReactComponent };